import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Includes } from './components/Includes';
import { Bonus } from './components/Bonus';
import { Audience } from './components/Audience';
import { Learn } from './components/Learn';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '2091189388346525';
export function App() {
  useEffect(() => {
    try {
      if (typeof window === 'undefined') return;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const w = window as any;
      if (w.fbq) {
        w.fbq('track', 'PageView');
        return;
      }
      // Standard Meta Pixel base code (official Facebook snippet, JS form)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ;
      (function (f: any, b: Document, e: string, v: string) {
        if (f.fbq) return;
        const n = f.fbq = function () {
          // eslint-disable-next-line prefer-rest-params
          n.callMethod ?
          // eslint-disable-next-line prefer-rest-params
          n.callMethod.apply(n, arguments) :
          // eslint-disable-next-line prefer-rest-params
          n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        s.parentNode && s.parentNode.insertBefore(t, s);
      })(w, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      w.fbq('init', META_PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch (err) {
      // Silently ignore — never let the pixel break the page
      console.error('Meta Pixel failed to load', err);
    }
  }, []);
  return <div className="min-h-screen bg-[#0D1117] text-white overflow-x-hidden font-sans selection:bg-[#2F80ED] selection:text-white" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>

      <Navbar data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <Includes data-id="element-6" />
        <Bonus data-id="element-7" />
        <Audience data-id="element-8" />
        <Learn data-id="element-9" />
        <Stats data-id="element-10" />
        <Pricing data-id="element-11" />
        <Testimonials data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}